module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.e07df86c.ttf";